import React, { Component } from "react";
import { Dropdown, DropdownMenu, DropdownItem, DropdownToggle } from "reactstrap";
import { getMessage } from "CONFIG/i18n";

import "./Menu.less"

import ic_picture_in_picture from "ASSETS/Images/video_menu/ic_picture_in_picture.svg";
import ic_fullscreen from "ASSETS/Images/video_menu/ic_switch_full_screen.svg";
import ic_video_menu from "ASSETS/Images/video_menu/ic_videoMenu.svg";

export default class VideoMenu extends Component {
  constructor(props) {
    super(props);
    this.state={
      show: false,
    }
  }

  toggle = () => {
    this.setState({ show: !this.state.show})
  }

  handlePictureInPicture = () => {
    this.props.handlePictureInPicture();
  }

  handleFullScreen = () => {
    this.props.handleFullScreen();
  }

  render() {
    return (
      <Dropdown isOpen={this.state.show} toggle={this.toggle} direction="down">
        <DropdownToggle className="toggle pr-2 pl-2" onClick={this.toggle}>
          {" "}
          <img
            src={ic_video_menu}
            id="videoMenu"
            title={getMessage("MENU")}
          />
        </DropdownToggle>

        <DropdownMenu right>

          { this.props.isPictureInPictureEnable &&
            <DropdownItem onClick={this.handlePictureInPicture}>
              <img src={ic_picture_in_picture} className="icons"/>
              {" " + getMessage("TOOLTIP_PICTURE_IN_PICTURE")}
            </DropdownItem>
          }

          { this.props.isFullScreenEnable &&
            <DropdownItem onClick={this.handleFullScreen}>
              <img src={ic_fullscreen} className="icons"/>
              {" " + getMessage("SCREEN_ZOOMIN")}
            </DropdownItem>
          }

        </DropdownMenu>
      </Dropdown>
    )
  }
}